import './style.css';

export class MobileMenu {
    constructor(el, options = {}) {
        const default_options = {
            width: '420'
        }   

        let v_el = el.detatch();

        this.options = Object.assign(default_options, options);
        this.rootElement = v_el;
        this.rootElement.setAttribute('data-role', 'mobile-menu');

        this.rootElement.style.setProperty('--dark-header-bg-color', Graphite.default(Graphite.config.mobile_menu.dark_header_bg_color, 'var(--bg-color)'));
        this.rootElement.style.setProperty('--light-header-bg-color', Graphite.default(Graphite.config.mobile_menu.light_header_bg_color, 'var(--bg-color)'));

        this.rootElement.style.setProperty('--dark-close-icon-color', Graphite.default(Graphite.config.mobile_menu.dark_close_icon_color, 'var(--icon-color)'));
        this.rootElement.style.setProperty('--light-close-icon-color', Graphite.default(Graphite.config.mobile_menu.light_close_icon_color, 'var(--icon-color)'));

        this.rootElement.style.setProperty('--dark-icon-color', Graphite.default(Graphite.config.mobile_menu.dark_icon_color, 'var(--icon-color)'));
        this.rootElement.style.setProperty('--light-icon-color', Graphite.default(Graphite.config.mobile_menu.light_icon_color, 'var(--icon-color)'));

        this.rootElement.style.setProperty('--dark-text-color', Graphite.default(Graphite.config.mobile_menu.dark_text_color, 'var(--text-color)'));
        this.rootElement.style.setProperty('--light-text-color', Graphite.default(Graphite.config.mobile_menu.light_text_color, 'var(--text-color)'));

        this.rootElement.setAttribute('data-dark-header-bg-hilight', Graphite.default(Graphite.config.mobile_menu.dark_header_bg_hilight, 'off'));
        this.rootElement.setAttribute('data-light-header-bg-hilight', Graphite.default(Graphite.config.mobile_menu.light_header_bg_hilight, 'off'));

        document.body.style.setProperty('--mobile-menu-width', this.options.width + 'px');
        document.body.prepend(this.rootElement);

        this.backdrop = document.createElement('div');
        this.backdrop.setAttribute('data-role', 'backdrop');

        this.rootElement.on('click', evt => {
            let el = evt.target;

            if (el.matches('header i')) {
                evt.preventDefault();
                this.hide();
            } else if (el.matches('a[data-cmd]')) {
                evt.preventDefault();

                let cmd = el.getAttribute('data-cmd');

                if (cmd == 'toggle-sub-menu') {
                    let li = el.closest('li');

                    if (li.hasClass('show-sub-menu')) {
                        li.classList.remove('show-sub-menu');
                    } else {
                        li.classList.add('show-sub-menu');
                    }
                }
            }
        })

        document.body.on('animationend', evt => {
            let animation = evt.animationName;

            if (animation == 'animate-menu-open') {

            } else if (animation == 'animate-menu-close') {
                setTimeout(() => {
                    document.documentElement.classList.remove('closing-mobile-menu');
                }, 300)
            }
        })

        this.backdrop.on('click', () => {
            this.hide();
        })

        document.body.prepend(this.backdrop);

        this.hamburger_menu = Graphite.el('<span id="hamburger_menu"><i class="icon-hamburger-menu"></i></span>');

        this.hamburger_menu.style.setProperty('--dark-bg-color', Graphite.default(Graphite.config.hamburger_menu.dark_bg_color, 'var(--bg-color)'));
        this.hamburger_menu.style.setProperty('--dark-icon-color', Graphite.default(Graphite.config.hamburger_menu.dark_icon_color, 'var(--icon-color)'));
        this.hamburger_menu.style.setProperty('--dark-outline-color', Graphite.default(Graphite.config.hamburger_menu.dark_outline_color, 'var(--outline-color)'));

        this.hamburger_menu.style.setProperty('--light-bg-color', Graphite.default(Graphite.config.hamburger_menu.light_bg_color, 'var(--bg-color)'));
        this.hamburger_menu.style.setProperty('--light-icon-color', Graphite.default(Graphite.config.hamburger_menu.light_icon_color, 'var(--icon-color)'));
        this.hamburger_menu.style.setProperty('--light-outline-color', Graphite.default(Graphite.config.hamburger_menu.light_outline_color, 'var(--outline-color)'));

        this.hamburger_menu.show = () => {
            this.hamburger_menu.classList.add('show');
        }

        this.hamburger_menu.hide = () => {
            this.hamburger_menu.classList.remove('show');
        }

        this.hamburger_menu.on('click', () => {
            this.show();
        })

        document.body.append(this.hamburger_menu);

        setTimeout(() => {
            this.rootElement.classList.add('ready');
        }, 100)
    }

    show() {
        document.documentElement.classList.remove('closing-mobile-menu');
        document.documentElement.classList.add('show-mobile-menu');
        this.hamburger_menu.hide();
    }

    hide() {
        document.documentElement.classList.add('closing-mobile-menu');        
        document.documentElement.classList.remove('show-mobile-menu');        

        this.hamburger_menu.show();
    }

    show_hamburger_menu() {
        this.hamburger_menu.classList.add('show');                
    }

    hide_hamburger_menu() {
        this.hamburger_menu.classList.remove('show');        
    }

    toggle() {
        if (document.documentElement.classList.contains('show-mobile-menu')) {
            this.hide();
        } else {
            this.show();
        }
    }

    is_show() {
        return document.documentElement.classList.contains('show-mobile-menu');        
    }
}